export function buildAssetPath(name) {
  return `https://raw.githubusercontent.com/CharlyMartin/animations-studio/master/website/${name}`;
  // return `https://raw.githubusercontent.com/LottiePremium/Animations/master/website/${name}`;
}
